import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as imageActions from '../../actions/imageActions';
import DiagramImageList from './DiagramImageList';
import Button from '../Global/Buttons/Button';
import ModalContainer from '../Global/Modals/ModalContainer';
import ModalHeader from '../Global/Modals/ModalHeader';
import ModalBody from '../Global/Modals/ModalBody';
import ModalFooter from '../Global/Modals/ModalFooter';

class SelectDiagramImageModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeItem: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    // Load diagram images on initial render
    if (this.props.modalIsOpen !== nextProps.modalIsOpen) {
      if (this.props.images.data.length === 0) {
        this.props.actions.loadImages(1);
      }
    }
  }

  toggleActiveDiagram = (diagram) => {
    let activeItem;
    if (this.state.activeItem && this.state.activeItem.id === diagram.id) {
      activeItem = null;
    } else {
      activeItem = diagram;
    }

    this.setState({ activeItem });
  }

  addDiagramImage = () => {
    this.props.onSelectDiagramClick(this.state.activeItem);
    this.closeModal();
  }

  closeModal = () => {
    this.setState({ activeItem: null });
    this.props.closeModal();
  }

  render() {
    const { modalIsOpen, images } = this.props;
    const { activeItem } = this.state;

    return (
      <ModalContainer
        isOpen={modalIsOpen}
        closeModal={this.closeModal}
        label="Select Diagram Modal"
      >
        <ModalHeader title="Select a diagram" onCloseClick={this.closeModal} />

        <ModalBody>
          <DiagramImageList
            diagrams={images.data}
            onDiagramClick={this.toggleActiveDiagram}
            activeItem={activeItem}
            loading={images.loading}
          />
        </ModalBody>

        <ModalFooter>
          <Button onClick={this.addDiagramImage} disabled={activeItem === null}>Select diagram</Button>
        </ModalFooter>
      </ModalContainer>
    );
  }
}

SelectDiagramImageModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  images: PropTypes.object.isRequired,
  onSelectDiagramClick: PropTypes.func.isRequired,
  actions: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    images: state.images,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, imageActions), dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectDiagramImageModal);



// WEBPACK FOOTER //
// ./library/app/components/Diagram/SelectDiagramImageModal.js